import React from "react"
import PropTypes from "prop-types"
import Panel from "@bappweb/panel"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"
import "src/assets/styles/style.scss"

const InfoBox = (props) => {

    return (
      <Panel key={props.key} hasFooter={false} noHeader id={props.id} className="infobox">
        <Block className="infobox-img-container">
          <Image path={props.img} className="infobox-img" />
        </Block>
        <Element type="p" className="infobox-text1">{props.text1}</Element>
        <Element type="p" className="infobox-text2">{props.text2}</Element>
      </Panel>      
    )
}

InfoBox.propTypes = {
  id: PropTypes.string,
  img: PropTypes.string,
  text1: PropTypes.string,
  text2: PropTypes.string
}

export default InfoBox
